<template>
    <notFoundComp></notFoundComp>
  </template>
  <script>
  import notFoundComp from "../../components/Error/NotFound.vue";
  
  export default {
    name: "notFoundComp",
    components: { notFoundComp },
    computed: {},
    mounted() {},
  };
  </script>
  